import Link from 'next/link'
import styled from 'styled-components'

export const Categories = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div:not(:last-child) {
    margin-right: 16px;
  }
`
export const Entries = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`
export const Entry = styled(Link)`
  text-decoration: none;
  color: var(--brand-secondary);
`
export const EntryImage = styled.div<{ image: string; height?: string }>`
  background-color: lightgrey;
  background-position: center center;
  background-size: cover;
  background-image: ${({ image }) => `url(${image});`}
  height: ${({ height }) => height || '500px'};
  border-radius: 20px;
  margin-bottom: 18px;
  
  @media (max-width: 768px) {
    height: 145px;
    border-radius: 16px;
  }
`

export const BlogEntryImage = styled(EntryImage)`
  @media (max-width: 768px) {
    height: 220px;
  }
`
